/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_PrintInputs */

const tr_landing_telegram_mock_btn_print = /** @type {(inputs: Landing_Telegram_Mock_Btn_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazdır`)
};

const en_landing_telegram_mock_btn_print = /** @type {(inputs: Landing_Telegram_Mock_Btn_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const de_landing_telegram_mock_btn_print = /** @type {(inputs: Landing_Telegram_Mock_Btn_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drucken`)
};

const ru_landing_telegram_mock_btn_print = /** @type {(inputs: Landing_Telegram_Mock_Btn_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Печать`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Landing_Telegram_Mock_Btn_PrintInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_print = /** @type {((inputs?: Landing_Telegram_Mock_Btn_PrintInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_PrintInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_print(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_print(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_print(inputs)
	return tr_landing_telegram_mock_btn_print(inputs)
});